import React, { useState, useEffect, useRef } from "react";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";

const Dropdown = ({
  options,
  name,
  icon,
  className,
  assetId,
  direction,
  onOptionSelect,
  returnFullObject = false,
  truncateText,
  size,
  disabled,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredOption, setHoveredOption] = useState(null);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const closeDropdown = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
      setHoveredOption(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", closeDropdown);
    return () => {
      document.removeEventListener("mousedown", closeDropdown);
    };
  }, []);

  const getDropdownPosition = () => {
    switch (direction) {
      case "right":
        return "right-5";
      case "left":
        return "left-5";
      default:
        return "center-5";
    }
  };

  const handleOptionClick = (option, subOption) => {
    const selectedValue = subOption ? subOption : option;
    if (onOptionSelect) {
      onOptionSelect(returnFullObject ? selectedValue : selectedValue.name);
    }
    setIsOpen(false);
  };

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className={className}
        disabled={disabled ? disabled : false}
      >
        {icon ? "" : name ? (truncateText ? truncateText(name, size) : name) : "Dropdown"}
        {icon ? icon : isOpen ? <FaChevronUp className="w-3 h-3" /> : <FaChevronDown className="w-3 h-3" />}
      </button>

      {isOpen && (
        <div
          className={`absolute ${getDropdownPosition()} mt-2 w-40 rounded-md shadow-lg bg-[#434A62] ring-1 ring-black ring-opacity-5 z-10 
          ${options.some((option) => option.subOptions) ? "" : "overflow-y-auto max-h-60"}`}
        >
          <div className="py-1">
            {options && options.length > 0 ? (
              options.map((option, index) => (
                <div
                  key={index}
                  onMouseEnter={() => setHoveredOption(option)}
                  onMouseLeave={() => {
                    if (!option.subOptions) setHoveredOption(null);
                  }}
                >
                  {option.subOptions ? (
                    <div className="relative">
                      <div
                        className={`block w-full text-left px-4 py-2 text-sm ${
                          hoveredOption === option
                            ? "bg-secondary text-primary"
                            : "hover:bg-secondary hover:text-primary"
                        }`}
                      >
                        {option.name}
                      </div>
                      {hoveredOption === option && (
                        <div
                          className="absolute left-full top-0 mt-0 w-40 rounded-md shadow-lg bg-[#434A62] ring-1 ring-black ring-opacity-5 z-20 
                          overflow-y-auto max-h-60"
                          onMouseEnter={() => setHoveredOption(option)}
                          onMouseLeave={() => setHoveredOption(null)}
                        >
                          <div className="py-1">
                            {option.subOptions.map((subOption, subIndex) => (
                              <button
                                key={subIndex}
                                onClick={() => handleOptionClick(option, subOption)}
                                className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-secondary hover:text-primary"
                              >
                                {subOption.name}
                              </button>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <button
                      onClick={() => handleOptionClick(option)}
                      className={`block w-full text-left px-4 py-2 text-sm break-words ${
                        (!hoveredOption && assetId === option.id)
                          ? "bg-secondary text-primary"
                          : hoveredOption === option
                          ? "bg-secondary hover:text-primary"
                          : "hover:bg-secondary hover:text-primary"
                      }`}
                    >
                      {truncateText ? truncateText(option.name, size) : option.name}
                    </button>
                  )}
                </div>
              ))
            ) : (
              <div className="block w-full text-left px-4 py-2 text-sm text-gray-400">No options</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
